// extracted by mini-css-extract-plugin
export var header = "_t7-1";
export var maskBottom = "_t7-6";
export var maskMiddle = "_t7-7";
export var maskTop = "_t7-5";
export var root = "_t7-0";
export var scrollDownButton = "_t7-3";
export var scrollDownButtonHidden = "_t7-4";
export var viewport = "_t7-2";